class LeagueAlreadyExistsError extends Error {
    constructor(m?: string) {
        super(m);
    }
}

export default LeagueAlreadyExistsError;
